import customerService from "@/services/customer";
import { useQuery } from "@tanstack/react-query";

type Props = {
  id: number;
};

function UseGetCustomerById({ id }: Props) {
  const { data, isLoading, refetch, isFetching, isSuccess } = useQuery(
    ["getCustomerById", id],
    () => customerService.getCustomerById(id),
    {
      enabled: Boolean(id),
    }
  );

  return { data, isLoading: isFetching && isLoading, refetch, isSuccess };
}

export default UseGetCustomerById;
